var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.002,
    height: 36,
    viewBox: "0 0 36.002 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffbe46;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.011)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.011)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 16.614,
    cy: 16.614,
    r: 16.614,
    transform: "translate(1.386 1.386)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18,36.011A18,18,0,0,1,5.266,5.276h0A18.01,18.01,0,1,1,18,36.011ZM7.239,7.249a15.22,15.22,0,1,0,21.525,0,15.24,15.24,0,0,0-21.525,0Z",
    transform: "translate(0 -0.011)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.761 11.594)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M168.667,177.388a1.4,1.4,0,0,1-.986-2.381l9.863-9.863a1.395,1.395,0,0,1,1.973,1.973l-9.863,9.863A1.394,1.394,0,0,1,168.667,177.388Z",
    transform: "translate(-167.27 -164.735)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M178.509,177.388a1.391,1.391,0,0,1-.986-.409l-9.863-9.863a1.395,1.395,0,0,1,1.973-1.973l9.863,9.863a1.4,1.4,0,0,1-.986,2.381Z",
    transform: "translate(-167.251 -164.735)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d5e2d6f22ff8a28c46ce8c27dc468511.svg";
export { ForwardRef as ReactComponent };